module.exports = __webpack_public_path__ + "img/nodata.8bb9640c.svg";